import { defineStore } from 'pinia'
import { ref } from 'vue'

export type SignUpCompany = {
  // step 0
  userName: string
  email: string
  phone1: string
  password: string
  confirmPassword: string
  // step 1
  companyName: string
  fantasyName: string
  cnpj: string
  corporateEmail: string
  corporatePhone1: string
  // step 2
  cep: string
  street: string
  number: string
  district: string
  complement: string
  state: string
  city: string
}

export type SignUpContractor = {
  // step 0
  userName: string
  email: string
  phone1: string
  phone2: string
  password: string
  confirmPassword: string
  // step 1
  companyName: string
  fantasyName: string
  cnpj: string
  corporateEmail: string
  corporatePhone1: string
  corporatePhone2: string
  // step 2
  cep: string
  street: string
  number: string
  district: string
  complement: string
  state: string
  city: string
}

function emptyCompany(): SignUpCompany {
  return {
    userName: '',
    email: '',
    phone1: '',
    password: '',
    confirmPassword: '',
    companyName: '',
    fantasyName: '',
    cnpj: '',
    corporateEmail: '',
    corporatePhone1: '',
    cep: '',
    street: '',
    number: '',
    district: '',
    complement: '',
    state: '',
    city: ''
  }
}

function emptyContractor(): SignUpContractor {
  return {
    userName: '',
    email: '',
    phone1: '',
    phone2: '',
    password: '',
    confirmPassword: '',
    companyName: '',
    fantasyName: '',
    cnpj: '',
    corporateEmail: '',
    corporatePhone1: '',
    corporatePhone2: '',
    cep: '',
    street: '',
    number: '',
    district: '',
    complement: '',
    state: '',
    city: ''
  }
}

export const useSignUpStore = defineStore('signUp', () => {
  const company = ref<SignUpCompany>(emptyCompany())
  const contractor = ref<SignUpContractor>(emptyContractor())

  function $reset() {
    company.value = emptyCompany()
    contractor.value = emptyContractor()
  }

  return { company, contractor, $reset }
})
